import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';
import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const getLscMapData = (state, setState) => {
    const api = initApi(API_NAMES.COMMON, state, setState);
    const url = `/OrgUnit/LscMaps`;

    return api?.executeObject ? api.executeObject(url, 'GET') : null;
};

const LscMapData = { 
  INITIAL_STATE: BASIC_INITIAL_STATE, 
  getLscMapData };

export default LscMapData;